import { grantsFreeMagnets, grantsFreeItem, freeItemLabel } from '../../utils/offerPricing';

// What the cart summary's coupon row says. A free-ITEM offer has no dollar
// discount; "Discount ... -$0.00" reads as a broken coupon (Alex, #5218
// walk-through) -- name what it grants instead, and skip the redundant
// "Subtotal after Savings" row that would repeat the subtotal. Pure so the
// branching is unit-testable (review on #5264).
export default function couponSummaryLine(coupon, discountValue) {
  // The free-item offer (#5747): the row names what it grants AND shows the
  // value taken off ("-$29.95"): the granted sheet is stamped at list price and
  // this coupon is what makes it free, so the deduction is a real number the
  // subtotal above includes. Nothing to take off yet (no pick made) reads as
  // a plain "Included" line.
  if (grantsFreeItem(coupon)) {
    const amount = typeof discountValue === 'number' ? discountValue : 0;
    return {
      text: `Included with each package: a FREE ${freeItemLabel(coupon)}`,
      value: amount > 0 ? discountValue : 'FREE',
      useMinus: amount > 0,
      showAfterSavings: amount > 0,
    };
  }
  if (grantsFreeMagnets(coupon)) {
    return {
      text: 'Included with your package:',
      value: '2 FREE photo magnets',
      useMinus: false,
      showAfterSavings: false,
    };
  }
  return {
    text: `Discount with code: ${coupon.code}`,
    value: discountValue,
    useMinus: typeof discountValue === 'number',
    showAfterSavings: true,
  };
}
